import { EventEmitter, Output, Directive, Input } from '@angular/core';
import { DrFileMeta, FileUploadStatus, DrFileUploadMeta } from '@app/shared/models/dr-file';
import { ConfirmModalComponent } from '@app/shared/dialogs/confirm-dialog/confirm-modal.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { FileListBaseComponent } from '@app/shared/components/file-upload/file-list-base.component';

@Directive()
export abstract class FileListComponent extends FileListBaseComponent {

    @Input()
    public labelProp?: string;

    @Output()
    public view = new EventEmitter<DrFileMeta>();

    @Output()
    public download = new EventEmitter<DrFileMeta>();

    @Output()
    public delete = new EventEmitter<DrFileMeta>();

    @Output()
    public edit = new EventEmitter<DrFileUploadMeta>();

    protected constructor(protected componentServiceBundle: ComponentServiceBundle) {
        super(componentServiceBundle);
    }

    public showFile(file: DrFileMeta): void {
        if (file.status === FileUploadStatus.READY && this.canView) {
            this.view.emit(file);
        }
    }

    public downloadFile(file: DrFileMeta): void {
        if (file.status === FileUploadStatus.READY && this.canDownload) {
            this.download.emit(file);
        }
    }

    public deleteFile(file: DrFileMeta): void {
        if (this.hasDeletableStatus(file) && this.canDelete && this.canDeleteDynamically(file)) {
            if (file.status === FileUploadStatus.READY) {
                const dialogRef = this.dialog.open(ConfirmModalComponent, {
                    width: '400px',
                    data: {
                        title: this.translateService.instant(marker('case.file.delete.title')),
                        text: `${this.translateService.instant(marker('case.file.delete.text'))} '${file.filename}'?`
                    }
                });

                dialogRef.afterClosed()
                    .subscribe((result: boolean) => {
                        if (result) {
                            this.delete.emit(file);
                        }
                    });
            } else {
                this.delete.emit(file);
            }
        }
    }

    public editFile(file: DrFileUploadMeta): void {
        this.edit.emit(file);
    }
}
